labels:
  invoices: Factuuroverzicht
messages:
  noInvoices: Er zijn nog geen facturen
actions:
  download: Downloaden
statuses:
  paid: Betaald
  failed: Mislukt
